"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getQIMEI = getQIMEI;
exports.getIDFV = getIDFV;
exports.getAndroidID = getAndroidID;
exports.getWifiInfo = getWifiInfo;
exports.getImsi = getImsi;
exports.getIMEI = getIMEI;
exports.getVersion = getVersion;
exports.getMacAddress = getMacAddress;
exports.getTuringTicket = getTuringTicket;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _promiseUtils = require("../promiseUtils");

function getQIMEI() {
  return _getQIMEI.apply(this, arguments);
}

function _getQIMEI() {
  _getQIMEI = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _window, _window$browser, _window$browser$devic;

    var _window2, _window2$browser, _window2$browser$devi;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!((_window = window) !== null && _window !== void 0 && (_window$browser = _window.browser) !== null && _window$browser !== void 0 && (_window$browser$devic = _window$browser.device) !== null && _window$browser$devic !== void 0 && _window$browser$devic.getQIMEI)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", (0, _promiseUtils.promisify)((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$browser = _window2.browser) === null || _window2$browser === void 0 ? void 0 : (_window2$browser$devi = _window2$browser.device) === null || _window2$browser$devi === void 0 ? void 0 : _window2$browser$devi.getQIMEI)());

          case 2:
            throw Error("getQIMEI error: no match jsapi");

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getQIMEI.apply(this, arguments);
}

function getIDFV() {
  return _getIDFV.apply(this, arguments);
}

function _getIDFV() {
  _getIDFV = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _window3, _window3$browser, _window3$browser$devi;

    var _window4, _window4$browser, _window4$browser$devi;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!((_window3 = window) !== null && _window3 !== void 0 && (_window3$browser = _window3.browser) !== null && _window3$browser !== void 0 && (_window3$browser$devi = _window3$browser.device) !== null && _window3$browser$devi !== void 0 && _window3$browser$devi.getIDFV)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", (0, _promiseUtils.promisify)((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$browser = _window4.browser) === null || _window4$browser === void 0 ? void 0 : (_window4$browser$devi = _window4$browser.device) === null || _window4$browser$devi === void 0 ? void 0 : _window4$browser$devi.getIDFV)());

          case 2:
            throw Error("getIDFV error: no match jsapi");

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getIDFV.apply(this, arguments);
}

function getAndroidID() {
  return _getAndroidID.apply(this, arguments);
}

function _getAndroidID() {
  _getAndroidID = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var _window5, _window5$browser, _window5$browser$devi;

    var _window6, _window6$browser, _window6$browser$devi;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!((_window5 = window) !== null && _window5 !== void 0 && (_window5$browser = _window5.browser) !== null && _window5$browser !== void 0 && (_window5$browser$devi = _window5$browser.device) !== null && _window5$browser$devi !== void 0 && _window5$browser$devi.getAndroidID)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", (0, _promiseUtils.promisify)((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$browser = _window6.browser) === null || _window6$browser === void 0 ? void 0 : (_window6$browser$devi = _window6$browser.device) === null || _window6$browser$devi === void 0 ? void 0 : _window6$browser$devi.getAndroidID)());

          case 2:
            throw Error("getAndroidID error: no match jsapi");

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getAndroidID.apply(this, arguments);
}

function getWifiInfo() {
  return _getWifiInfo.apply(this, arguments);
}

function _getWifiInfo() {
  _getWifiInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var _window7, _window7$browser, _window7$browser$devi;

    var _window8, _window8$browser, _window8$browser$devi;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!((_window7 = window) !== null && _window7 !== void 0 && (_window7$browser = _window7.browser) !== null && _window7$browser !== void 0 && (_window7$browser$devi = _window7$browser.device) !== null && _window7$browser$devi !== void 0 && _window7$browser$devi.getWifiInfo)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", (0, _promiseUtils.promisify)((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$browser = _window8.browser) === null || _window8$browser === void 0 ? void 0 : (_window8$browser$devi = _window8$browser.device) === null || _window8$browser$devi === void 0 ? void 0 : _window8$browser$devi.getWifiInfo)());

          case 2:
            throw Error("getWifiInfo error: no match jsapi");

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getWifiInfo.apply(this, arguments);
}

function getImsi() {
  return _getImsi.apply(this, arguments);
}

function _getImsi() {
  _getImsi = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var _window9, _window9$browser, _window9$browser$devi;

    var _window10, _window10$browser, _window10$browser$dev;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!((_window9 = window) !== null && _window9 !== void 0 && (_window9$browser = _window9.browser) !== null && _window9$browser !== void 0 && (_window9$browser$devi = _window9$browser.device) !== null && _window9$browser$devi !== void 0 && _window9$browser$devi.getImsi)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", (0, _promiseUtils.promisify)((_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$browser = _window10.browser) === null || _window10$browser === void 0 ? void 0 : (_window10$browser$dev = _window10$browser.device) === null || _window10$browser$dev === void 0 ? void 0 : _window10$browser$dev.getImsi)());

          case 2:
            throw Error("getImsi error: no match jsapi");

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getImsi.apply(this, arguments);
}

function getIMEI() {
  return _getIMEI.apply(this, arguments);
}

function _getIMEI() {
  _getIMEI = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var _window11, _window11$browser, _window11$browser$dev;

    var _window12, _window12$browser, _window12$browser$dev;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!((_window11 = window) !== null && _window11 !== void 0 && (_window11$browser = _window11.browser) !== null && _window11$browser !== void 0 && (_window11$browser$dev = _window11$browser.device) !== null && _window11$browser$dev !== void 0 && _window11$browser$dev.getIMEI)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return", (0, _promiseUtils.promisify)((_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$browser = _window12.browser) === null || _window12$browser === void 0 ? void 0 : (_window12$browser$dev = _window12$browser.device) === null || _window12$browser$dev === void 0 ? void 0 : _window12$browser$dev.getIMEI)());

          case 2:
            throw Error("getIMEI error: no match jsapi");

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getIMEI.apply(this, arguments);
}

function getVersion() {
  return _getVersion.apply(this, arguments);
}

function _getVersion() {
  _getVersion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var _window13, _window13$browser, _window13$browser$dev;

    var _window14, _window14$browser, _window14$browser$dev;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!((_window13 = window) !== null && _window13 !== void 0 && (_window13$browser = _window13.browser) !== null && _window13$browser !== void 0 && (_window13$browser$dev = _window13$browser.device) !== null && _window13$browser$dev !== void 0 && _window13$browser$dev.getVersion)) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", (0, _promiseUtils.promisify)((_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$browser = _window14.browser) === null || _window14$browser === void 0 ? void 0 : (_window14$browser$dev = _window14$browser.device) === null || _window14$browser$dev === void 0 ? void 0 : _window14$browser$dev.getVersion)());

          case 2:
            throw Error("getVersion error: no match jsapi");

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getVersion.apply(this, arguments);
}

function getMacAddress() {
  return _getMacAddress.apply(this, arguments);
}

function _getMacAddress() {
  _getMacAddress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var _window15, _window15$browser, _window15$browser$dev;

    var _window16, _window16$browser, _window16$browser$dev;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!((_window15 = window) !== null && _window15 !== void 0 && (_window15$browser = _window15.browser) !== null && _window15$browser !== void 0 && (_window15$browser$dev = _window15$browser.device) !== null && _window15$browser$dev !== void 0 && _window15$browser$dev.getMacAddress)) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return", (0, _promiseUtils.promisify)((_window16 = window) === null || _window16 === void 0 ? void 0 : (_window16$browser = _window16.browser) === null || _window16$browser === void 0 ? void 0 : (_window16$browser$dev = _window16$browser.device) === null || _window16$browser$dev === void 0 ? void 0 : _window16$browser$dev.getMacAddress)());

          case 2:
            throw Error("getMacAddress error: no match jsapi");

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getMacAddress.apply(this, arguments);
}

function getTuringTicket() {
  return _getTuringTicket.apply(this, arguments);
}

function _getTuringTicket() {
  _getTuringTicket = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var _window17, _window17$browser, _window17$browser$dev;

    var _window18, _window18$browser, _window18$browser$dev;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!((_window17 = window) !== null && _window17 !== void 0 && (_window17$browser = _window17.browser) !== null && _window17$browser !== void 0 && (_window17$browser$dev = _window17$browser.device) !== null && _window17$browser$dev !== void 0 && _window17$browser$dev.getTuringTicket)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return", (0, _promiseUtils.promisify)((_window18 = window) === null || _window18 === void 0 ? void 0 : (_window18$browser = _window18.browser) === null || _window18$browser === void 0 ? void 0 : (_window18$browser$dev = _window18$browser.device) === null || _window18$browser$dev === void 0 ? void 0 : _window18$browser$dev.getTuringTicket)());

          case 2:
            throw Error("getTuringTicket error: no match jsapi");

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getTuringTicket.apply(this, arguments);
}

var _default = {
  getQIMEI: getQIMEI,
  getIDFV: getIDFV,
  getAndroidID: getAndroidID,
  getWifiInfo: getWifiInfo,
  getImsi: getImsi,
  getIMEI: getIMEI,
  getVersion: getVersion,
  getMacAddress: getMacAddress,
  getTuringTicket: getTuringTicket
};
exports["default"] = _default;